<template>
  <div class="content mailing-list">
    <h2>{{ $t("mailling.title") }}</h2>
    <p>{{ $t("mailling.text") }}</p>
    <div class="subscribe-form">
        <input type="text" :placeholder="$t('mailling.placeholder')" class="mail-input" />
        <input type="button" :value="$t('mailling.joinBtn')" class="mail-submit" />
    </div>
  </div>
</template>

<script>
export default {
  name: "MailList",
  components: {},
};
</script>

<style scoped>
.mailing-list {
    padding: 1rem 0;
    text-align: center;
    h2 {
        font-size: 8vw;
    }
    p {
        font-size: 4vw;
        margin: 1.5rem 0;
    }
    .subscribe-form {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    input {
        height: 50px;
        border: none;
        border-radius: 5rem;
    }
    input:focus {
        outline: none;
    }
    .mail-input {
        width: 90vw;
        padding: 0 2rem;
        background-color: white;
    }
    .mail-submit {
        width: 30vw;
        color: white;
        font-size: 4.5vw;
        cursor: pointer;
        padding: 0;
        font-weight: 800;
        margin-left: -4rem;
        background: linear-gradient(90deg, #06A5FF 0%, #3DDE91 100%);
    }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .mailing-list {
        padding: 1rem 0;
        text-align: center;
        h2 {
            font-size: 1.5rem;
        }
        p {
            font-size: 1rem;
            margin: 1.5rem 0;
        }
        .subscribe-form {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        input {
            height: 50px;
            border: none;
            border-radius: 5rem;
        }
        input:focus {
            outline: none;
        }
        .mail-input {
            width: 30rem;
            padding: 0 2rem;
            background-color: white;
        }
        .mail-submit {
            width: 10rem;
            color: white;
            font-size: 1.2rem;
            cursor: pointer;
            padding: 0;
            font-weight: 800;
            margin-left: -4rem;
            background: linear-gradient(90deg, #06A5FF 0%, #3DDE91 100%);
        }
    }
}
</style>
